import script from "./configuration.vue?vue&type=script&setup=true&lang=js"
export * from "./configuration.vue?vue&type=script&setup=true&lang=js"

import "./configuration.vue?vue&type=style&index=0&id=73fc724e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fc724e"]])

export default __exports__